import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class UserService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.USER(), data);
    }

    getMatchingTree(id, data): Observable<any> {
        return this.getRequest(AppUrl.MATCHING_TREE(id), data);
    }
    getMatchingTreeByUsername(data): Observable<any> {
        return this.getRequest(AppUrl.MATCHING_TREE(), data);
    }
    getDownlineMember(id, data): Observable<any> {
        return this.getRequest(AppUrl.DOWNLINE_MEMBER(id), data);
    }

    getMyMembers(data): Observable<any> {
        return this.getRequest(AppUrl.MY_MEMBERS(), data);
    }

    getCountDirectSponsor(data): Observable<any> {
        return this.getRequest(AppUrl.MY_MEMBERS_COUNT_SPONSOR(), data);
    }

    getSelfRepurchaseBasicValue(data): Observable<any> {
        return this.getRequest(AppUrl.SELF_REPURCHASE_BASIC_VALUE_COUNT(), data);
    }

    getSelfRepurchaseTeamBasicValue(data): Observable<any> {
        return this.getRequest(AppUrl.SELF_REPURCHASE_TEAM_BASIC_VALUE_COUNT(), data);
    }

    selfDetail(): Observable<any> {
        return this.getRequest(AppUrl.USER());
    }

    selfAddress(data): Observable<any> {
        return this.getRequest(AppUrl.ADDRESS(), data);
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.USER(), data);
    }

    update(data): Observable<any> {
        return this.putRequest(AppUrl.USER(), data);
    }

    updatePAN(data): Observable<any> {
        return this.putRequest(AppUrl.USER_PAN(), data);
    }

    updateAadhar(data): Observable<any> {
        return this.putRequest(AppUrl.USER_AADHAR(), data);
    }

    updateBank(data): Observable<any> {
        return this.putRequest(AppUrl.USER_BANK(), data);
    }

    updateNominee(data): Observable<any> {
        return this.putRequest(AppUrl.USER_NOMINEE(), data);
    }
    addMoneyInWallet(unique_id, data) : Observable<any> {
        return this.putRequest(AppUrl.ADD_MONEY_TO_WALLET(unique_id), data);
    }
}
